const config = {};

export const MAX_CHALLENGES = 6;
export const REVEAL_TIME_MS = 350;
export const GAME_START_DATE = "2022/08/23";

export default config;
